import { render } from "./AppointmentStatusSummary.vue?vue&type=template&id=70d418f1&scoped=true"
import script from "./AppointmentStatusSummary.vue?vue&type=script&lang=js"
export * from "./AppointmentStatusSummary.vue?vue&type=script&lang=js"

import "./AppointmentStatusSummary.vue?vue&type=style&index=0&id=70d418f1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d418f1"]])

export default __exports__